import { Box, styled } from '@mui/material';
import { DateTime } from 'luxon';
import { RenderUnsettledUI } from 'shared/components';
import { useOnScrollDownWithoutTotal } from 'redesign';
import { usePlanningParamsContext } from '../../../providers/planning-params-provider';
import { useGetCalendarShiftsPlanning } from '../hooks/use-get-shifts-planning';
import { CalendarShift } from '../calendar-shift/calendar-shift';

export const CalendarPlanning = () => {
  const { filters } = usePlanningParamsContext();
  const startOfWeek = filters.date?.startOf('week') || DateTime.now().startOf('week');
  const endOfWeek = startOfWeek.plus({ days: 6 });

  const planningQuery = useGetCalendarShiftsPlanning({
    branchOffices: filters.branchOfficeIds,
    departments: filters.departmentIds,
    fromDate: startOfWeek.toISODate(),
    toDate: endOfWeek.toISODate(),
    jobType: filters.jobType,
    hasApplicants: filters.hasApplicants,
    filledStatus: filters.filledStatus,
    partnerId: filters.partner,
    isFreelance: filters.isFreelance,
    isTempWork: filters.isTempWork,
    isEmployee: filters.isEmployee,
  });

  const { data } = planningQuery;

  const flatData =
    data?.pages?.flatMap((page) =>
      page.planning.departments.map((dpt) => {
        const { id, name, branchOffice } = dpt;

        return {
          id,
          name: [branchOffice.name, name].join('\r\n'),
          jobTypes: dpt.jobTypes.map((jobType) => ({
            id: jobType.id,
            name: jobType.name,
            shifts: jobType.shifts.map((shift) => ({
              id: shift.id,
              dateLabel: shift.dateLabel,
              dateTime: shift.dateTime,
              jobName: shift.jobName,
              startTime: shift.startTime,
              endTime: shift.endTime,
              applicants: shift.applicants,
              claimants: shift.claimants,
              flexPoolOnly: shift.flexPoolOnly,
              maxClaimants: shift.maxClaimants,
              hasPartners: shift.hasPartners,
              hasCanceledClaim: shift.hasCanceledClaim,
            })),
          })),
        };
      })
    ) ?? [];

  const { fetchIfBottomScrolled: onScroll } = useOnScrollDownWithoutTotal({
    infiniteQueryResult: planningQuery,
  });

  if (planningQuery.status !== 'success') {
    return <RenderUnsettledUI data={planningQuery} />;
  }

  return (
    <StyledContainer>
      <CalendarShift data={flatData} onScroll={onScroll} />
    </StyledContainer>
  );
};

const StyledContainer = styled(Box)({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
});
